import React, {Component} from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import axios from 'axios';

import {Button, Form, Layout, Col, Carousel, Row, Modal, Icon} from 'antd';
import InputText from './interfaz/InputText.js';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {change} from '../utils/funciones.js';
import {Link} from "react-router-dom"
import AuthenticatedComponent from './AuthenticatedComponent'
import imgLogo from '../img/1_login.png'
import infoIcon from '../img/info_icon.png'
import TemplateExterno from './interfaz/TemplateExterno';
import { implantarAspirante, setCurrentUser, setCurrentUserRol, userLogout } from '../redux/user/user-actions';
import { obtieneProcesosDetalle, obtieneEstados, obtieneDistritos, obtieneParticipacion } from '../redux/menu/menu-utils';
import { updateDetalle, updateEstado, updateDistrito, updateListaEstados, updateListaProcesos, updateListaDistritos } from '../redux/menu/menu-actions';
import { selectEstado } from '../redux/menu/menu-selectors';
import * as etiquetas from '../ApplicationResources';
import guiaAspirante from '../documentos/guia_aspirante.pdf';
import carrouselCapacitador from '../img/carrousel_capacitador.png';
import carrouselSupervisor from '../img/carrousel_supervisor.png';
import iconoMegafono from '../img/icons/megaphone-fill.svg';
import { ReactSVG } from 'react-svg'
import { selectCurrentUser } from '../redux/user/user-selectors.js';

//Llave creada con el correo reclutaseycae@gmail.com
const CAP_KEY = "6LexEeIcAAAAAERV_iFUDmdSPi5w-EHHRIQ9RArE";
const {Sider, Content} = Layout;
let recaptchaInstance;

var today = new Date();

class Login extends Component {
	state = {
		peticion: {},
		mensajeError: '',
		username: undefined,
		password: undefined,
		cargando: false,
		media: null,
		nav: null,
		mjs: "",
		modalAbrir: false,
		inputTypePwd: "password",
		pwdSeleccionado: false,
		botonMostrar: "Mostrar contraseña"
	}

	constructor(props) {
		super(props);
	}

	componentDidMount = () => {
		this.setState({
		  media: this.media,
		  nav: this.nav
		});

		if(this.props.location.state && this.props.location.state.inactividad) {
			// Abrimos el modal por inactividad
			this.abrirModal(etiquetas.login_lbl_mensaje_inactividad);
			// Limpiamos el estado de la inactividad
			this.props.history.replace({ state: {inactividad:false} })
		}
	  };

	redireccionContacto = () => {
		this.props.history.push('/no_recibi_correo')
	}

	submit = () => {
		try{
			this.props.form.validateFields(async(err, values) => {
			//this.props.form.haValidado = true;
				if (!err){
					values["usuario"] = values["usuario"].trim();
					values["userP"] = values["password"].trim();

					values["idSistema"] = etiquetas.idSistema;

					this.setState({cargando: true});

					const response = await axios.post(process.env.REACT_APP_API_URL +
						'/centralReclutaSEyCAE/ws/validateUser', values).then(async(res) => {
						const datos = res.data.entity.datosUsuario;
						const entidad = res.data.entity;

						if (entidad && entidad.code === 200) {
							localStorage.setItem('jwt-token', datos.tknJWT);
							localStorage.setItem('id_detalle_proceso', datos.idDetalle);
							localStorage.setItem('id_estado', datos.idEstado);

							// Actualizamos el estado de currentUser en la store con los datos del usuario
							this.props.setCurrentUser(datos);
							
							if(datos.tipoUsuario === 'I') {
								// Consultamos los estados del idEstado y idDistrito del usuario
								const estados = await obtieneEstados(0, 0, "D", datos.idEstado, datos.idDistrito, 0, "ROL");

								// Actualizamos la lista de estados
								this.props.updateListaEstados(estados);
								// Actualizamos el idEstado que trae el usuario
								this.props.updateEstado(datos.idEstado);
								this.props.updateDistrito(datos.idDistrito);

								// Si el idEstado participa en algún proceso electoral y es diferente de 0 significa que es un JL o JD, hay que consultar los procesos en ese estado
								if(this.props.estado !== undefined && datos.idEstado > 0) {
									// Consultamos los procesos del idEstado correspondiente
									const procesos = await obtieneProcesosDetalle(datos.idEstado, datos.idDistrito, 0, "F");
									// Actualizamos la lista de procesos en el idEstado del usuario
									this.props.updateListaProcesos(datos.idEstado, procesos);
								}

								// Validamos el rol que tiene el usuario de acuerdo a su idEstado y idDistrito
								if(datos.idEstado === 0 && datos.idDistrito === 0) {
									this.props.setCurrentUserRol("OC");
								} else if(datos.idEstado !== 0 && datos.idDistrito === 0) {
									this.props.setCurrentUserRol("JL");
								} else {
									this.props.setCurrentUserRol("JD");
								}
							} else {
								// Usuario interno
								const idProcesoElectoral = datos.datosAspirante.idProcesoElectoral;
								const idDetalleProceso = datos.datosAspirante.idDetalleProceso;
								const idEstado = datos.datosAspirante.idEstado;
								const idDistrito = datos.datosAspirante.idDistrito;
								const estadosAspirante = await obtieneEstados(0, 0, "D", idEstado, idDistrito, 0, "ROL");
								const procesosAspirante = await obtieneProcesosDetalle(idEstado, idDistrito, 0, "F");
								const distritosAspirante = await obtieneDistritos(idProcesoElectoral, idDetalleProceso, "D", idEstado, idDistrito, 0, "D");
								datos.datosAspirante.fechaFinCapsula = datos.fechaFinCapsula;
								// Actualizamos el idEstado que trae el usuario
								this.props.updateEstado(idEstado);
								// Actualizamos el idDistrito que trae el usuario
								this.props.updateDistrito(idDistrito);
								// Actualizamos el detalle del usuario
								this.props.updateDetalle(idDetalleProceso);
								// Consultamos los estados del idEstado y idDistrito del usuario
								// Actualizamos la lista de estados
								this.props.updateListaEstados(estadosAspirante);
								// Obtenemos los procesos electorales
								this.props.updateListaProcesos(idEstado, procesosAspirante);
								// Actualizamos la lista de distritos
								this.props.updateListaDistritos(idDetalleProceso, idEstado, 
									distritosAspirante);

								this.props.implantarAspirante(datos.datosAspirante);
							}

							//Direccionando por tipo de usuario
							if(datos.tipoUsuario === 'I')
								this.props.history.push('/menuJDE');
							else {
								if (datos.datosAspirante.estatusRegistro === 1)
									this.props.history.push('/cargaDocumentos');
								else if (datos.datosAspirante.estatusRegistro === 2) {
									if (datos.datosAspirante.bObservacion)
										this.props.history.push('/cargaDocumentos');
									else if (typeof datos.datosAspirante.bObservacion !== "number" &&
											datos.datosAspirante.bPlatica === 0)
										this.props.history.push('/finalizado');
									else
										this.props.history.push('/platica_induccion');
								}
								else if (datos.datosAspirante.estatusRegistro === 3){
									if(datos.datosAspirante.bPlatica === null){
										this.props.history.push('/platica_induccion');
									}else{
										this.props.history.push('/finalizado');
									}
								}
								else if (datos.datosAspirante.estatusRegistro === 4 || datos.datosAspirante.estatusRegistro === 5)
									this.props.history.push('/solicitud_declinada');
								else
									this.props.history.push('/enConstruccion');
							}
						}
						else {
							this.props.history.push('/loginSEyCAE');
							this.props.userLogout();
							var mensajeError = "";

							if(entidad.code === 201)
								mensajeError = etiquetas.login_lbl_mensaje_codigo_201;
							else if(entidad.code === 202)
								mensajeError = etiquetas.login_lbl_mensaje_codigo_202;
							else if(entidad.code === 203)
								mensajeError = etiquetas.login_lbl_mensaje_codigo_203;
							else if(entidad.code === 204)
								mensajeError = etiquetas.login_lbl_mensaje_codigo_204;
							else if(entidad.code === 205)
								mensajeError = etiquetas.login_lbl_mensaje_codigo_205;
							else if(entidad.code === 207)
								mensajeError = etiquetas.login_lbl_mensaje_codigo_207;
							else
								mensajeError = etiquetas.login_lbl_mensaje_codigo_500;

							this.setState({
								//Asignando mensajes de error.
								mensajeError: mensajeError
							});
						}
						this.setState({cargando: false});
					}).catch(() => {
						this.setState({cargando: false});
					});
      			}
			});

    	}catch(error){
			console.log('Authorization failed : ' + error.message);
			this.setState({cargando: false});
			//this.handlerLoadingLogin(false);
	  	} 
	}
	
	changePwd= (e) => {
		this.state.pwdSeleccionado = !this.state.pwdSeleccionado;
		if(this.state.pwdSeleccionado){
			this.state.inputTypePwd = "text";
			this.setState({inputType: "text",
						   botonMostrar: "Ocultar contraseña"
		})
		}else{
			this.state.inputTypePwd = "password"
			this.setState({inputType: "password",
			botonMostrar: "Mostrar contraseña"})
		}
	}

	abrirModal = (mensaje) => {
		this.setState({modalAbrir: true, mjs: mensaje});
	}

	cerrarModal = () =>{
        this.setState({modalAbrir: false, msj:""});
    }

	render() {
		return (
			<GoogleReCaptchaProvider
			reCaptchaKey={CAP_KEY}
			language="es-419" >
				<AuthenticatedComponent privado={false}>
					<TemplateExterno enlaces={false} bloquearTodo={true} bloqueado={this.state.cargando}>
					<Row justify="center">
						<Col xs={24} sm={24} md={24} lg={24} offset={3} className='contenedor_principal_login'>
							<Col xs={24} sm={12} md={12} lg={12} className='login_col_2'>
								<Col xs={24} sm={24} md={24} lg={24} className='text_col_1'>
									EL INE TE INVITA A COLABORAR COMO PERSONA <span className='login_etiquetas_capacitador_supervisor'>SUPERVISORA</span><br />
									O <span className='login_etiquetas_capacitador_supervisor'>CAPACITADORA ASISTENTE</span> DURANTE EL PROCESO ELECTORAL
								</Col>
								<Col xs={24} sm={24} md={24} lg={24}>
									<Carousel
										autoplay={true}
										autoplaySpeed={5000}
										slidesToShow={1}
										asNavFor={this.state.media}
										draggable={true}
										ref={carousel => (this.nav = carousel)}
										swipeToSlide={true}
										touchThreshold={50}
										focusOnSelect={true}
										>
										<div>
											<img src={carrouselCapacitador} alt="Capacitador" className='imagen-carrousel' />
										</div>
										<div>
											<img src={carrouselSupervisor} alt="Supervisor" className='imagen-carrousel' />
										</div>
									</Carousel>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='text_col_1'>
									<span>
										<img src={iconoMegafono} className='icono_megafono' />
										<Link to="/consulta_convocatoria" className='text_convocatorias'>Consulta la convocatoria</Link>
									</span>
								</Col>
								

							</Col>
							<Col xs={24} sm={12} md={12} lg={12} className='login_col_2'>
								<Col xs={24} sm={24} md={24} lg={24}>
									<img src={imgLogo} alt="" className='logo_login'/>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='login_col_2'>
									<InputText  nombre="usuario"
										form={this.props.form}
										style={{width: '50%'}}
										type="user"
										inputType="text"
										required={true}
										onChange={(valor)=>{this.setState({username:valor})}}
										placeholder={etiquetas.login_lbl_usuario}/>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='login_col_2'>
								<InputText 	nombre="password"
										form={this.props.form}
										style={{width: '50%'}}
										type="lock"
										inputType={this.state.inputTypePwd}
										required={true}
										onChange={(valor)=>{this.setState({password:valor})}}
										placeholder={etiquetas.login_lbl_constrasenia}
										title={etiquetas.login_msg_constrasenia}><Icon id="icon-contacto" type="eye-invisible" theme="filled"/></InputText>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='separacion_filas_login_2'>
								<Button className="botonesModal2" style={{width: 150}} onClick={this.changePwd}> {this.state.botonMostrar} </Button>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='separacion_filas_login_2'>
									<span><font color="red">{this.state.mensajeError}</font></span>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='separacion_filas_login_2'>
									<Button type="primary"
											className="button_style"
											id="btn-sesion"
											onClick={this.submit}>
										{etiquetas.login_btn_inicioSesion}
									</Button>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='separacion_filas_login_2'>
									<span>
										<img src={infoIcon} className='img_info_icon' />
										<Link to={guiaAspirante} target = "_blank" rel="noopener noreferrer" className='link_guia_registro'>Guía de registro</Link>
									</span>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='separacion_filas_login_2'>
									<span>
										<span className='label_eres_nuevo'>¿Eres nuevo? </span>
										<Link to="/registro_aspirante" className='link_registrate'>Regístrate</Link>
									</span>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='separacion_filas_login_2'>
									<Button type="primary"
											className="button_style"
											id="btn-sesion"
											onClick={this.redireccionContacto}>
										No recib&iacute; correo electr&oacute;nico
									</Button>
								</Col>
								<Col xs={24} sm={24} md={24} lg={24} className='separacion_filas_login_2 link_aviso_privacidad_integral'>
									<a href={etiquetas.AVISO_PRIVACIDAD_INTEGRAL} target="_blank"
										>
										{etiquetas.login_lbl_aviso_privacidad_integral}
									</a>
								</Col>
							</Col>
						</Col>
					</Row>
					</TemplateExterno>

					<Modal title={null}
                       centered
                       visible={this.state.modalAbrir}
                       onOk={null}
                       onCancel={null}
                       closable={false}
                       footer={null}>
                    <div style={{'fontSize': '16px'}}>
                        {this.state.mjs}
                    </div>
                    <br/><br/>
                    <div id="modal_botones">
                        <Button className="botonesModal" style={{width: 150}} onClick={this.cerrarModal}> Aceptar </Button>
                    </div>
                	</Modal>
				</AuthenticatedComponent>
			</GoogleReCaptchaProvider>
		);
	}
}

const mapDispatchToProps = dispatch => ({
	userLogout: () => dispatch(userLogout()),
	setCurrentUser: user => dispatch(setCurrentUser(user)),
	implantarAspirante: aspirante => dispatch(implantarAspirante(aspirante)),
	setCurrentUserRol: rol => dispatch(setCurrentUserRol(rol)),
	updateEstado: estado => dispatch(updateEstado(estado)),
	updateListaEstados: estados => dispatch(updateListaEstados(estados)),
	updateDetalle: detalle => dispatch(updateDetalle(detalle)),
	updateListaProcesos : (idEstado, procesos) => dispatch(updateListaProcesos(idEstado, procesos)),
	updateListaDistritos: (idDetalle, idEstado, distritos) => dispatch(updateListaDistritos(idDetalle, idEstado, distritos)),
	updateDistrito: distrito => dispatch(updateDistrito(distrito))
});

const mapStateToProps = createStructuredSelector({
	estado: selectEstado,
	datosUsuario: selectCurrentUser
});

const Login2 = Form.create({name: 'login_form'})(Login);

export default connect(mapStateToProps, mapDispatchToProps)(Login2);
